import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Send } from "lucide-react";
import { useTranslation } from "react-i18next";
import PostList from "../components/posts/PostList";
import { getProfile } from "../services/api";

// 🌍 Lista de países europeos con códigos y banderas
const europeanCountries = [
  { code: "DE", name: "Alemania", flag: "🇩🇪" },
  { code: "AT", name: "Austria", flag: "🇦🇹" },
  { code: "BE", name: "Bélgica", flag: "🇧🇪" },
  { code: "BG", name: "Bulgaria", flag: "🇧🇬" },
  { code: "HR", name: "Croacia", flag: "🇭🇷" },
  { code: "CY", name: "Chipre", flag: "🇨🇾" },
  { code: "CZ", name: "Chequia", flag: "🇨🇿" },
  { code: "DK", name: "Dinamarca", flag: "🇩🇰" },
  { code: "SK", name: "Eslovaquia", flag: "🇸🇰" },
  { code: "SI", name: "Eslovenia", flag: "🇸🇮" },
  { code: "ES", name: "España", flag: "🇪🇸" },
  { code: "EE", name: "Estonia", flag: "🇪🇪" },
  { code: "FI", name: "Finlandia", flag: "🇫🇮" },
  { code: "FR", name: "Francia", flag: "🇫🇷" },
  { code: "GR", name: "Grecia", flag: "🇬🇷" },
  { code: "HU", name: "Hungría", flag: "🇭🇺" },
  { code: "IE", name: "Irlanda", flag: "🇮🇪" },
  { code: "IT", name: "Italia", flag: "🇮🇹" },
  { code: "LV", name: "Letonia", flag: "🇱🇻" },
  { code: "LT", name: "Lituania", flag: "🇱🇹" },
  { code: "LU", name: "Luxemburgo", flag: "🇱🇺" },
  { code: "MT", name: "Malta", flag: "🇲🇹" },
  { code: "NL", name: "Países Bajos", flag: "🇳🇱" },
  { code: "PL", name: "Polonia", flag: "🇵🇱" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "RO", name: "Rumanía", flag: "🇷🇴" },
  { code: "SE", name: "Suecia", flag: "🇸🇪" },
];


const FeedPage = () => {
  const { t } = useTranslation();
  const [selectedCountry, setSelectedCountry] = useState(null);

  // Al cargar, obtener el país del usuario
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getProfile();
        if (res.data.country) {
          setSelectedCountry(res.data.country.toUpperCase());
        } else {
	  setSelectedCountry("");
	}
      } catch (err) {
        console.error("Error al obtener el perfil:", err);
        setSelectedCountry("");
      }
    };

    fetchProfile();
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-3 sm:px-5 pt-2 md:pt-12 pb-10">
        <div className="mb-4 flex items-center justify-between gap-3 md:max-w-3xl md:mx-auto md:px-2">
          <select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
            className="h-[52px] border border-sky-200 bg-white px-4 rounded-xl text-xl shadow-sm text-[#245580] focus:outline-none focus:ring-2 focus:ring-[#247BA8] cursor-pointer"
          >
            <option value="">🇪🇺</option>
            {europeanCountries.map((country) => (
              <option key={country.code} value={country.code}>
                {country.flag}
              </option>
            ))}
          </select>

          <Link
            to="/new-post"
            className="inline-flex h-[52px] w-[52px] shrink-0 items-center justify-center rounded-xl bg-green-50 text-[#16A34A] shadow-sm transition hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-[#16A34A] focus:ring-offset-2"
            aria-label={t("navbar.new_post", "Publicar")}
            title={t("navbar.new_post", "Publicar")}
          >
            <Send className="h-6 w-6" />
          </Link>
        </div>

      {/* 📜 Lista de posts con filtro */}
      {selectedCountry !== null && <PostList countryFilter={selectedCountry} />}
    </div>
  );
};

export default FeedPage;
